module.exports = __webpack_public_path__ + "static/best-meets-requirements-fall-78a030d87a5f8a6dc00200b7df41a330.svg";